import { BrowserRouter } from "react-router-dom";
import Pagination from "./Pages/Pagination";
import React from "react";

import { createStore } from "redux";
import reducer from "./Redux/RootReducer";
import { Provider } from "react-redux";

const FormatRoutes = () => {
  const store = createStore(reducer);
  return (
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <Pagination />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
};

export default FormatRoutes;
